module.exports = __webpack_public_path__ + "img/1.4700d550.png";